import React from 'react';
import { Helmet } from 'react-helmet';
import { getServerSideURL } from '../../../utils/node/get-url';

const BreadcrumbData = ({ title, pathname, parentName, parentURL }) => {
  const baseUrl = getServerSideURL();

  return (
    <Helmet>
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "${baseUrl}/"
              },{
                "@type": "ListItem",
                "position": 2,
                "name": "${parentName || title}",
                "item": "${parentURL ? `${baseUrl}${parentURL}` : `${baseUrl}${pathname}`}"
              }${parentName || parentURL ? (`,{
                  "@type": "ListItem",
                  "position": 3,
                  "name": "${title}",
                  "item": "${baseUrl}${pathname}"
                }
              `) : (
                ''
              )}
            ]
          }
        `}
      </script>
    </Helmet>
  );
};

export default BreadcrumbData;
